/**
 * True when interpreting job creation should not require a physical service location
 * (aligned with backend is_remote / admin CreateJob logic).
 */
const REMOTE_INTERPRETING_SERVICE_TYPES = ['video', 'video_medical', 'phone', 'phone_conference'];

const REMOTE_TELEHEALTH_APPOINTMENT_TYPES = new Set([
  'phone',
  'video',
  'consult_telehealth',
  'follow_up_telehealth',
  'medical_telehealth',
  'deposition_zoom',
  'status_conference_remote'
]);

export function interpretingJobServiceLocationOptional(formData) {
  if (!formData) return false;
  if (formData.serviceType === 'document') return true;
  if (REMOTE_INTERPRETING_SERVICE_TYPES.includes(formData.serviceType)) return true;
  const apt = String(formData.appointmentType || '').trim();
  return apt !== '' && REMOTE_TELEHEALTH_APPOINTMENT_TYPES.has(apt);
}

/** Phone-only remote jobs skip the location wizard step entirely. */
export function shouldSkipLocationStep(serviceType) {
  return serviceType === 'phone' || serviceType === 'phone_conference';
}
